<template>
    <v-hover v-slot="{ hover }">
        <v-btn type="submit" :color="color" class="text-white" elevation="10" @click="func(value)"
               :style="{ 'background-image': hover ? color : '' }">
                <span class="material-icons mr-1" style="font-size: 15pt">{{ iconName }}</span>
            {{ buttonName }}
        </v-btn>
    </v-hover>
</template>
<!--:style="{ 'color': hover ? 'white' : '' }"-->
<script>
export default {
    name: "buttonTempl",
    props: {
        color: {
            require: true,
            default: 'info'
        },
        buttonName: {
            default: 'ثبت آگهی',
            require: true
        },
        func: {
            require: true,
            default: (value) => {
            }
        },
        iconName: {
            default: ''
        }
    },

}
</script>

<style>
.submit-btn {
    margin: 10px;
    padding: 15px 60px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.7s !important;
    background-size: 200% auto;
    display: block;
}

.submit-btn:hover {
    background-position: right center; /* change the direction of the change here */
    color: #fff !important;
    text-decoration: none !important;
    border: none;
    transition: 0.7s !important;
    box-shadow: 0 0 30px #eee;

}


</style>
